import generic_backend_request_post from 'functions/server/generic_backend_request_post';

async function get_user_plan(user_id) {
    /**
     * This function sends a POST request to the backend server to get the user's plan.
     * It takes in the user_id and returns the response from the server.
     * 
     * @param {string} user_id - The ID of the user to get the plan for.
     * @returns {Object} - The response from the server.
     */
    if (!user_id) {
        throw new Error('User ID is required for get_user_plan');
    }
    const requestJson = {
        "user_id": user_id
    }
    const retJson = await generic_backend_request_post(requestJson, '/user_plan')
    return retJson;
}

export default get_user_plan
